import I from "../../@babel/runtime/helpers/esm/extends2.mjs";
import X from "../../@babel/runtime/helpers/esm/defineProperty2.mjs";
import Y from "../../@babel/runtime/helpers/esm/typeof2.mjs";
import p from "../../@babel/runtime/helpers/esm/slicedToArray2.mjs";
import Z from "../../classnames/index2.mjs";
import $ from "../../rc-util/es/KeyCode.mjs";
import * as t from "react";
import ee from "../../rc-util/es/pickAttrs.mjs";
var le = /* @__PURE__ */ t.forwardRef(function(e, h) {
  var A = e.prefixCls, F = e.style, S = e.className, d = e.duration, c = d === void 0 ? 4.5 : d, T = e.showProgress, E = e.pauseOnHover, m = E === void 0 ? !0 : E, K = e.eventKey, L = e.content, r = e.closable, N = e.closeIcon, w = N === void 0 ? "x" : N, a = e.props, P = e.onClick, j = e.onNoticeClose, y = e.times, q = e.hovering, H = t.useState(!1), C = p(H, 2), O = C[0], M = C[1], R = t.useState(0), g = p(R, 2), s = g[0], z = g[1], B = t.useState(0), k = p(B, 2), i = k[0], G = k[1], u = q || O, f = c > 0 && T, v = function() {
    j(K);
  }, J = function(n) {
    (n.key === "Enter" || n.code === "Enter" || n.keyCode === $.ENTER) && v();
  };
  t.useEffect(function() {
    if (!u && c > 0) {
      var n = Date.now() - i, o = setTimeout(function() {
        v();
      }, c * 1e3 - i);
      return function() {
        m && clearTimeout(o), G(Date.now() - n);
      };
    }
  }, [c, u, y]), t.useEffect(function() {
    if (!u && f && (m || i === 0)) {
      var n = performance.now(), o, V = function _() {
        cancelAnimationFrame(o), o = requestAnimationFrame(function(U) {
          var W = U + i - n, D = Math.min(W / (c * 1e3), 1);
          z(D * 100), D < 1 && _();
        });
      };
      return V(), function() {
        m && cancelAnimationFrame(o);
      };
    }
  }, [c, i, u, f, y]);
  var x = t.useMemo(function() {
    return Y(r) === "object" && r !== null ? r : r ? {
      closeIcon: w
    } : {};
  }, [r, w]), Q = ee(x, !0), b = 100 - (!s || s < 0 ? 0 : s > 100 ? 100 : s), l = "".concat(A, "-notice");
  return /* @__PURE__ */ t.createElement("div", I({}, a, {
    ref: h,
    className: Z(l, S, X({}, "".concat(l, "-closable"), r)),
    style: F,
    onMouseEnter: function(n) {
      var o;
      M(!0), a == null || (o = a.onMouseEnter) === null || o === void 0 || o.call(a, n);
    },
    onMouseLeave: function(n) {
      var o;
      M(!1), a == null || (o = a.onMouseLeave) === null || o === void 0 || o.call(a, n);
    },
    onClick: P
  }), /* @__PURE__ */ t.createElement("div", {
    className: "".concat(l, "-content")
  }, L), r && /* @__PURE__ */ t.createElement("a", I({
    tabIndex: 0,
    className: "".concat(l, "-close"),
    onKeyDown: J,
    "aria-label": "Close"
  }, Q, {
    onClick: function(n) {
      n.preventDefault(), n.stopPropagation(), v();
    }
  }), x.closeIcon), f && /* @__PURE__ */ t.createElement("progress", {
    className: "".concat(l, "-progress"),
    max: "100",
    value: b
  }, b + "%"));
});
export {
  le as default
};
//# sourceMappingURL=Notice.mjs.map
